jQuery(($) => {
	if (window.location.hash && window.location.hash === "#sweepstakes") {
		$("#sweepstakes").removeClass("hidden");

		/* 		$("#footer").append(
        '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=125603944727793&ev=PageView" /><img style="width:1px; height:1px;" src="https://servedby.flashtalking.com/spot/1/15214;141510;12636/?spotName=2024_SWA_Sweepstakes_SunsetontheBeach_Pageview&cachebuster=[' +
            Math.floor(Math.random() * 31231432431212) +
            ']" />'
    ); */
	}
	if (window.location.hash && window.location.hash === "#confirmation") {
		$("#sweepstakes").addClass("hidden");
		$("#confirmation").removeClass("hidden");
	}
	if (window.location.hash && window.location.hash === "#entered") {
		$("#sweepstakes").addClass("hidden");
		$("#entered").removeClass("hidden");
	}
});

function scrollToTop() {
	const toTop = () => {
		window.scrollTo({ top: 0, left: 0, behavior: "auto" });
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;
	};

	// Run now, next frame, and after short delays so we beat the browser's
	// native scroll to the #confirmation / #entered hash target.
	toTop();
	requestAnimationFrame(toTop);
	setTimeout(toTop, 50);
	setTimeout(toTop, 250);
}

function cheersSuccess(form, response, whatForm = 6) {
	console.log("Success!", response);
	form.style.display = "none";

	document.getElementById("sweepstakes").classList.add("hidden");
	document.getElementById("confirmation").classList.remove("hidden");

	window.location.hash = "confirmation";
	const random = Math.floor(Math.random() * 10000000000000000000);

	scrollToTop();

	$("#footer").append(`
		<div style="position:absolute;">
		<img src="https://www.facebook.com/tr?id=125603944727793&amp;ev=PageView&amp;noscript=1&amp;dl=https://www.SouthwestCubsSweepstakes.com/%23confirmation" style="display:none; border=0px; height=1px; width=1px;" alt=""></div>
	`);
}

function cheersError(form, error) {
	console.error("Error!", error.message);
	document.getElementById("cheers-error").classList.remove("hidden");
}

function initSweepstakesForm() {
	const sweepstakesForm = document.getElementById("sweepstake-form");
	if (!sweepstakesForm) return;

	const formName = sweepstakesForm.getAttribute("name");
	const form = document.forms[formName];
	if (!form) return;

	let isSubmitting = false;

	form.addEventListener("submit", async (e) => {
		e.preventDefault();

		if (isSubmitting) return;
		isSubmitting = true;

		// Does #sweepstakes have class basketball
		/* const isBasketball = document
				.getElementById("sweepstakes")
				.classList.contains("basketball"); */

		let whatForm = 6;
		/* if (isBasketball) {
				whatForm = 2;
			} */

		const formData = getFormData(whatForm);
		//const email = formData[9]; // email is field 9
		//const mailchimpData = getMailchimpData(formData);

		try {
			const rewardsField = document.getElementById("form_field_rewards");
			const mbrCardNumber = rewardsField?.value || "";
			const isValid = transformMbrCardNumber(mbrCardNumber);

			if (isValid) {
				const hasDuplicate = await checkForDuplicates(
					formData,
					whatForm,
				);

				if (hasDuplicate) {
					isSubmitting = false;

					/* if (isBasketball) {
							document
								.getElementById("sweepstakes")
								.classList.add("hidden");

							document
								.getElementById("entered")
								.classList.remove("hidden");
						} else { */
					document
						.getElementById("sweepstakes")
						.classList.add("hidden");
					document
						.getElementById("entered")
						.classList.remove("hidden");
					//}

					scrollToTop();

					return;
				}

				await submitForm(formData, form, whatForm);
				//console.log("Mailchimp Data:", mailchimpData);
				//await submitToMailchimp(email, mailchimpData); //mailchimpData
			} else {
				console.log("Invalid card number");
				setRewardsFieldValidity(false);

				return;
			}
		} catch (error) {
			console.error("An error occurred during submission:", error);
		} finally {
			isSubmitting = false;
		}
	});

	function getFormData(whatForm = 6) {
		const prom = document.querySelector("#form_field_promotional_emails")
			?.checked
			? "Yes"
			: "No";

		const consent = document.querySelector("#consent")?.checked
			? "Yes"
			: "No";

		const sms = document.querySelector("#form_field_sms")?.checked
			? "Yes"
			: "No";

		return {
			3: document.querySelector("#form_field_name").value,
			5: document.querySelector("#form_field_last").value,
			8: normalizePhoneForSearch(
				document.querySelector("#form_field_phone").value,
			),
			9: normalizeEmailForSearch(
				document.querySelector("#form_field_email").value,
			),
			10: document.querySelector("#form_field_rewards").value,
			6: document.querySelector("#form_field_state").value,
			19: document.querySelector("#incoming_urls").value,
			18: document.querySelector("#referrer_source").value,
			15: document.querySelector("#utm_source").value,
			17: document.querySelector("#utm_medium").value,
			16: document.querySelector("#utm_campaign").value,
			14.1: prom,
			12.1: consent,
			20.1: sms,
			form_id: whatForm,
		};
	}

	function getMailchimpData(formData) {
		return {
			FNAME: formData[3] || "", // First name
			LNAME: formData[5] || "", // Last name
			PHONE: formData[8] || "", // Phone number
			STATE: formData[6] || "", // State
			COMMERCIAL: formData[12.1] === "Yes" ? "yes" : "no", // Convert "Yes" to 1 and "No" to 0
			RAPID: formData[10] || "", // Rewards field
		};
	}

	function normalizePhoneForSearch(phone) {
		return String(phone || "").replace(/\D/g, "");
	}

	function normalizeEmailForSearch(email) {
		return String(email || "")
			.trim()
			.toLowerCase();
	}

	async function checkForDuplicates(formData, whatForm = 6) {
		try {
			const phone = normalizePhoneForSearch(formData[8]);
			const email = normalizeEmailForSearch(formData[9]);

			if (!phone && !email) {
				return false;
			}

			const phoneMatchCount = phone
				? await fetchEntryCountByField(8, phone, whatForm)
				: 0;
			const emailMatchCount = email
				? await fetchEntryCountByField(9, email, whatForm)
				: 0;

			if (phoneMatchCount > 0 || emailMatchCount > 0) {
				console.warn("Duplicate entry detected", {
					formId: whatForm,
					phoneMatches: phoneMatchCount,
					emailMatches: emailMatchCount,
					phone,
					email,
				});
			}

			return phoneMatchCount > 0 || emailMatchCount > 0;
		} catch (error) {
			console.error("Error during duplicate check:", error);
			return false;
		}
	}

	async function fetchEntryCountByField(fieldKey, fieldValue, whatForm = 6) {
		const searchParams = new URLSearchParams({
			search: JSON.stringify({
				field_filters: [
					{
						key: fieldKey.toString(),
						value: fieldValue,
						operator: "is",
					},
				],
			}),
			"paging[page_size]": "1",
			"paging[current_page]": "1",
		});

		try {
			const response = await $.ajax({
				type: "GET",
				url: `https://southwestCubsSweepstakes.com/wp-json/gf/v2/forms/${whatForm}/entries?${searchParams}`,
				beforeSend: (xhr) => {
					xhr.setRequestHeader(
						"Authorization",
						"Basic " +
							btoa(
								"ck_00070598a0487836e17116ef38dc5e05e340be02:cs_85d208349c7a9d0715c2cab22cb10823f5744036",
							),
					);
				},
				contentType: "application/json",
			});

			if (typeof response.total_count === "number") {
				return response.total_count;
			}

			return Array.isArray(response.entries)
				? response.entries.length
				: 0;
		} catch (error) {
			throw new Error(`
					Fetch entries by field failed: ${error.responseText}
				`);
		}
	}

	function submitForm(formData, form, whatForm) {
		return $.ajax({
			type: "POST",
			url: `https://southwestCubsSweepstakes.com/wp-json/gf/v2/forms/${whatForm}/entries`,
			beforeSend: (xhr) => {
				xhr.setRequestHeader(
					"Authorization",
					"Basic " +
						btoa(
							"ck_00070598a0487836e17116ef38dc5e05e340be02:cs_85d208349c7a9d0715c2cab22cb10823f5744036",
						),
				);
			},
			data: JSON.stringify(formData),
			contentType: "application/json",
			success: (response) => {
				console.log("Form submitted successfully!");
				cheersSuccess(form, response, whatForm);
			},
			error: (response) => {
				cheersError(form, response);
				console.error(
					"Form submission failed: ",
					response.responseText,
				);
			},
		});
	}

	async function submitToMailchimp(email, mergeFields = {}) {
		const mailchimpData = {
			email_address: email,
			merge_fields: mergeFields,
			status: "subscribed", // Or "pending" for double opt-in
		};

		try {
			const response = await fetch(
				"https://mailchimptia.netlify.app/.netlify/functions/subscribe-to-mailchimp",
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(mailchimpData),
				},
			);

			if (!response.ok) {
				const error = await response.json();
				throw new Error(
					error.error || "Failed to subscribe user to Mailchimp.",
				);
			}

			const data = await response.json();
			console.log("User subscribed successfully:", data.message);
		} catch (error) {
			console.error("Mailchimp subscription error:", error);
		}
	}
}

if ($("#sweepstake-form").length > 0) {
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initSweepstakesForm);
	} else {
		initSweepstakesForm();
	}
}

function bootRewardsValidation() {
	initRewardsValidation();
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", bootRewardsValidation);
} else {
	bootRewardsValidation();
}

function isValidEmail(email) {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(String(email).toLowerCase());
}

function normalizeRewardsNumber(mbrCardNumber) {
	return String(mbrCardNumber || "").replace(/\D/g, "");
}

function setRewardsFieldValidity(isValid) {
	const rewardsField = document.getElementById("form_field_rewards");
	const rewardsError = document.getElementById("cheers-rewards-error");

	if (!rewardsField) return;

	const hasInput = normalizeRewardsNumber(rewardsField.value).length > 0;

	if (!hasInput) {
		rewardsField.classList.remove("valid", "invalid");
		rewardsError?.classList.add("hidden");
		return;
	}

	rewardsField.classList.toggle("valid", isValid);
	rewardsField.classList.toggle("invalid", !isValid);
	rewardsError?.classList.toggle("hidden", isValid);
}

function initRewardsValidation() {
	const rewards = document.getElementById("form_field_rewards");
	if (!rewards || rewards.dataset.rewardsValidationBound === "true") {
		return;
	}

	rewards.dataset.rewardsValidationBound = "true";

	const validateRewards = () => {
		setRewardsFieldValidity(transformMbrCardNumber(rewards.value));
	};

	rewards.addEventListener("input", validateRewards);
	rewards.addEventListener("paste", validateRewards);
}

function transformMbrCardNumber(mbrCardNumber) {
	let normalizedNumber = normalizeRewardsNumber(mbrCardNumber);

	if (!normalizedNumber) {
		return false;
	}

	if (normalizedNumber.length < 14) {
		normalizedNumber = normalizedNumber.padStart(14, "0");
	}

	if (normalizedNumber.length !== 14) {
		return false;
	}

	const first13Digits = Number(normalizedNumber.substring(0, 13));
	const checkDigit = normalizedNumber.charAt(13);

	if (!/^\d$/.test(checkDigit)) {
		return false;
	}

	return String(first13Digits % 7) === checkDigit;
}

if (document.querySelector("button.button")) {
	document
		.querySelector("button.button")
		.addEventListener("click", function () {
			let consent = document.getElementById("consent")?.checked;
			let fields = true;
			if (
				document.getElementById("form_field_name").value == "" &&
				document.getElementById("form_field_last").value == "" &&
				document.getElementById("form_field_email").value == "" &&
				document.getElementById("form_field_phone").value == "" &&
				document.getElementById("form_field_state").value == ""
			) {
				fields = false;
			}

			if (fields) {
				if (!consent) {
					document
						.getElementById("cheers-error-checks")
						.classList.remove("hidden");
				}
			}
		});
}
